import { DrsDeductEarningHist } from "../DrsDeductEarningHist";
import { DrsSettleHist } from "../DrsSettleHist";
import { EscrowTable } from "../EscrowTable";
import { GLDistributionTable } from "../GLDistributionTable";
import { Settlement401kTable } from "../Settlement401kTable";
import { TableLeave } from "../TableLeave";
import { TimecardHistoryDetails } from "../TimecardHistoryDetails";
import { Button, DataHeader, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementPayrollHistory extends Layout {
    buttonReverse: Button;
    buttonStateTaxCode: Button;
    dataheaderGeneral: DataHeader;
    horizontalspacer12: HorizontalSpacer;
    horizontalspacer13: HorizontalSpacer;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacer8: HorizontalSpacer;
    labelA: Label;
    labelEmployer: Label;
    labelHeaderTotal: Label;
    labelWages: Label;
    labelWitholdings: Label;
    layout401kDetails: Settlement401kTable;
    layoutDrsDeductEarningHist: DrsDeductEarningHist;
    layoutDrsSettleHist: DrsSettleHist;
    layoutEscrowTable: EscrowTable;
    layoutImageTable: Layout;
    layoutJournalDriver: GLDistributionTable;
    layoutTableLeave: TableLeave;
    layoutTimecardHistoryDetails: TimecardHistoryDetails;
    panelAccountingInterface: Panel;
    panelCity: Panel;
    panelCounty: Panel;
    panelCutoff: Panel;
    panelDeduction: Panel;
    panelEmpLiability: Panel;
    panelEtt: Panel;
    panelFed: Panel;
    panelFuta: Panel;
    panelG: Panel;
    panelHeader: Panel;
    panelMed: Panel;
    panelMediCare: Panel;
    panelPfml2: Panel;
    panelPfml: Panel;
    panelSS: Panel;
    panelSSN: Panel;
    panelSUI: Panel;
    panelSUICounty: Panel;
    panelSdi2: Panel;
    panelSdi: Panel;
    panelState: Panel;
    panelWages: Panel;
    panelWitholding: Panel;
    panelsui: Panel;
    sourceDrs401kHist: DataSource;
    sourceDrsDeductHist: DataSource;
    sourceDrsPayrollHist: DataSource;
    sourceDrsSettleHist: DataSource;
    sourceDrsTimecardHist: DataSource;
    sourceEscrowTransaction: DataSource;
    sourceJournalDriver: DataSource;
    sourceLeaveTransaction: DataSource;
    switchProcessed: Switch;
    switchVoided: Switch;
    tab401kDetails: Tab;
    tabEscrow: Tab;
    tabGLDistribution: Tab;
    tabImages: Tab;
    tabInterfaces: Tab;
    tabLeaveHistory: Tab;
    tabPayAdjustments: Tab;
    tabSettlement: Tab;
    tabTabCheckInfo: Tab;
    tabTimecard: Tab;
    tabsetGeneral: Tabset;
    textboxBonusCodeId: Textbox;
    textboxCheckAmount: Textbox;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxCity: Textbox;
    textboxCityTaxCode: Textbox;
    textboxCityWith: Textbox;
    textboxCounty: Textbox;
    textboxCountyTaxCode: Textbox;
    textboxCountyWith: Textbox;
    textboxETT: Textbox;
    textboxEmployerEtt: Textbox;
    textboxEmployerFicaHi: Textbox;
    textboxEmployerFicaSs: Textbox;
    textboxEmployerFui: Textbox;
    textboxEmployerPfml: Textbox;
    textboxEmployerSdi: Textbox;
    textboxEmployerSui: Textbox;
    textboxFactoringCompany: Textbox;
    textboxFed: Textbox;
    textboxFederal: Textbox;
    textboxFuta: Textbox;
    textboxGpExported: Textbox;
    textboxLiabInsurance: Textbox;
    textboxMed: Textbox;
    textboxMedicare: Textbox;
    textboxNTaxable: Textbox;
    textboxOldBalApplied: Textbox;
    textboxPayPeriod: Textbox;
    textboxPayType: Textbox;
    textboxPayeeCode: Textbox;
    textboxPayeePayMethod: Textbox;
    textboxPaymentMethod: Textbox;
    textboxPfml: Textbox;
    textboxPfmlWith: Textbox;
    textboxR: Textbox;
    textboxSSN: Textbox;
    textboxSSWith: Textbox;
    textboxSUI: Textbox;
    textboxSUIWage: Textbox;
    textboxSdi: Textbox;
    textboxSource: Textbox;
    textboxState: Textbox;
    textboxStateTaxId: Textbox;
    textboxStateWith: Textbox;
    textboxSuiWagesTot: Textbox;
    textboxSuiWith: Textbox;
    textboxT401K: Textbox;
    textboxT401kCatchup: Textbox;
    textboxT: Textbox;
    textboxTDeduction: Textbox;
    textboxTotDeduct: Textbox;
    textboxTotGrossPay: Textbox;
    textboxTotSetPerdiem: Textbox;
    textboxTotTrailerRent: Textbox;
    textboxTotWorkmanComp: Textbox;
    textboxVoidDate: Textbox;
    textboxsdi: Textbox;
}
